import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import Mdatatable from "components/Datatables/Mdatatables"
import Notifications from "components/Notifications"
import DeleteConfirmationModel from "components/delete-confirmation-model"
import { getCode, userModuleData } from 'helpers/basic_helper'
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap"
import { GetHelper, SubmitHelper } from '../Masters/CallHelper'
import FormComponent from "../Masters/FormComponent"
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";
import { getBasePermissions } from "modules/Utility/getPermission";

const isType = 'category'
const Category = () => {
    const module = getBasePermissions('product_master');
    const canAdd = module?.isAdmin || Boolean(module?.menu?.product_master?.product_category?.add);
    const canEdit = module?.isAdmin || Boolean(module?.menu?.product_master?.product_category?.edit);
    const canDelete = module?.isAdmin || Boolean(module?.menu?.product_master?.product_category?.delete);
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState({})
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isEdit, setIsEdit] = useState(false)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [error, setError] = useState(false);
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })
    
    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async(ID = false) => {
        if (!ID) setIsLoading(true)
        const res = await GetHelper(`${process.env.REACT_APP_PRODUCTCATEGORY}&page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, ID)
        if(ID){
            setEditableObj(...res)
            isOpen(true)
            setIsEdit(false)
        }else{
            setDataRows(res)
        }

        setIsLoading(false)
        if(res === undefined){
            setError(true)
        }
    }
    
    /**
     * Submit or Update data Api Call
     * @param {Form Data} data 
     * @method {post} POST 
     */
    const submitForm = async(data) => {
        const checkCode = dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.target.code.value).toUpperCase())
        if(data?.target?.id?.value =='' && checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        const res = await SubmitHelper(`${process.env.REACT_APP_PRODUCTCATEGORY}`, {
            "title": data.target.title.value,
            "code": data.target.code.value
        }, data?.target?.id?.value || null);

        if(res){
            getData()
            isOpen(false)
            Notifications('You have successfully added a Product Category.!')
        }
    }

    /**
     * Get Single row using url params ?q=?
     * @param {Row_id} q 
     * @method {get} GET 
     */
    const handleEdit = q => {
        if(q > 0){
            setIsEdit(q)
            getData(q)
        }
    }

    /**
     * Chnage Row Status By ID and condition Based Status passing,
     * @param {row_id} q 
     * @param {row Status} status 
     * @method {del} DELETE 
     */
    const handleRemove = async(q, status, code) => {
        if(q > 0) {
            setIsDeleteModel({url: process.env.REACT_APP_PRODUCTCATEGORY, q, status, code})
        }
    }

    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        }, {
            dataField: 'title',
            text: 'Product Category'
        },{
            dataField: 'code',
            text: 'Product Category Code'
        }
    ];

    const showActionColumn = canEdit || canDelete;

    if(showActionColumn){
        datatableData = [...datatableData, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => {
                if (!canEdit && !canDelete) return null;

                return (
                <>
                    {canEdit && (
                    <Link
                        to="#"
                        className="btn btn-outline-secondary btn-sm edit"
                        onClick={() => handleEdit(row.id)}
                        title="Edit"
                    >
                        <i className="fas fa-pencil-alt" />
                    </Link>
                    )}

                    {canDelete && (
                    <Link
                        to="#"
                        className="ms-1 btn btn-outline-danger btn-sm edit"
                        onClick={() => handleRemove(row.id, row.status, row.code)}
                        title="Delete"
                    >
                        <i className="fas fa-trash-alt" />
                    </Link>
                    )}
                </>
                );
            },
        }]
    }

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj?editableObj.id : '',
            col:12
        },{
            name: "title",
            label: "Product Category",
            placeholder: "Please Enter Product Category",
            required: true,
            type: 'text',
            value: editableObj?editableObj.title : '',
            col:12
        },{
            name: "code",
            label: "Product Category Code",
            placeholder: "Please Enter Product Code",
            required: true,
            type: 'text',
            value: editableObj?editableObj.code: getCode("productcategory", dataRows?.total_rows),
            col: 12
        }
    ]

    useEffect(async() => {
        const data =  await userModuleData('product_master', 'product_category')
        setIsActions(data)
        if(data && (data?.edit || data?.delete)){
            setIsActionColumn(true)
        }
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Dashboard | {isType}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title="Masters"
                        breadcrumbItem={isType}
                    />

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={true}
                                        columns = {datatableData}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.total_rows || 0}
                                        rows = {dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={()=>{
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}            
                                        title = "All Categories"
                                        loading={isLoading}
                                        isAdd = {canAdd}
                                        isTableHead = {true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* End Datatable */}                    
            {
                open &&
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} Category`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={isLoading}
                    editableObj={editableObj}
                    onDrawerClose={() => {
                        setEditableObj(null)
                        isOpen(!open)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}

            { isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} /> }
        </React.Fragment>
    )
}

export default Category
